module.exports = __webpack_public_path__ + "static/media/DK.076dafc8.svg";